"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["className", "title", "subtitle", "linkUrl", "linkElement", "children", "color", "uppercase", "body", "iconType"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridSelectorItem = exports.GridSelector = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _arrowIcon = _interopRequireDefault(require("../arrow-icon"));
var _heading = _interopRequireDefault(require("../heading"));
var _icon = _interopRequireDefault(require("../icon"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const GridSelector = _ref => {
  let {
    children,
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.GridSelector, className)
  }, children);
};
exports.GridSelector = GridSelector;
GridSelector.propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string
};
const GridSelectorItem = _ref2 => {
  let {
      className,
      title,
      subtitle,
      linkUrl,
      linkElement,
      children,
      color,
      uppercase,
      body,
      iconType
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  // eslint-disable-next-line jsx-a11y/anchor-has-content
  const Link = linkElement || (props => /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({}, props, {
    href: linkUrl
  })));
  return /*#__PURE__*/_react.default.createElement(Link, {
    className: (0, _classnames.default)(_indexModule.default.GridSelectorItem, className, {
      [_indexModule.default.seasonal]: color === 'seasonal',
      [_indexModule.default.black]: color === 'black',
      [_indexModule.default.uppercase]: uppercase
    })
  }, iconType === null ? null : /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: iconType,
    size: "medium",
    className: _indexModule.default.icon
  }), /*#__PURE__*/_react.default.createElement("section", null, /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "small",
    "data-test-id": props.dataTestTitle
  }, title), /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "extrasmall",
    className: _indexModule.default.subtitle,
    "data-test-id": props.dataTestSubtitle
  }, subtitle), body && /*#__PURE__*/_react.default.createElement(_heading.default, {
    type: "extrasmall",
    className: _indexModule.default.subtitle,
    "data-test-id": props.dataTestBody
  }, body)), children && /*#__PURE__*/_react.default.createElement("section", {
    className: _indexModule.default.itemBody
  }, children), /*#__PURE__*/_react.default.createElement(_arrowIcon.default, {
    className: _indexModule.default.arrow
  }));
};
exports.GridSelectorItem = GridSelectorItem;
GridSelectorItem.defaultProps = {
  color: 'seasonal',
  uppercase: true
};
GridSelectorItem.propTypes = {
  className: _propTypes.default.string,
  title: _propTypes.default.string.isRequired,
  subtitle: _propTypes.default.string,
  dataTestSubtitle: _propTypes.default.string,
  dataTestBody: _propTypes.default.string,
  dataTestTitle: _propTypes.default.string,
  linkUrl: _propTypes.default.string,
  linkElement: _propTypes.default.func,
  children: _propTypes.default.node,
  color: (0, _propTypes.oneOf)(['black', 'seasonal']),
  uppercase: _propTypes.default.bool,
  body: _propTypes.default.node,
  iconType: _propTypes.default.string
};